import React, { useState, useEffect, useContext, useRef } from 'react';
import './mobile-fotogalerie-duo-jamaha-desktop.css';
import './mobile-fotogalerie-duo-jamaha-mobile.css';
import NavbarDesktop from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


import MenuMobile from "../../komponenty/navbar-mobile/menu.js";
// ikony
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaGooglePlus } from "react-icons/fa";

import 'animate.css';



function MobileFotogalerieRauty() {
  return (
    <div>

{/* mobile sekce */}
      <div className='mobile-vypnuti'>

          <div id="menu-mobile-main">
            <MenuMobile />
          </div>

{/* navbar */}
        <div id='cely-navbar' className='cely-navbar'>
          <img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-1'></img>

          <div className='navar-pozadi'>
            <h1 className='hospudka-pod-rablinu-nazev-1 animate__animated animate__backInLeft'>Hospůdka pod Rablinů</h1>
            <h3 className='hospudka-pod-rablinu-nazev-2 animate__animated animate__backInLeft'>Ta pravá chuť Valašska</h3>
          </div>
      
          <img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-2'></img>

          <div id="menu-mobile-externi">
            <MenuMobile />
          </div>

        </div>
{/* konec navbaru */}

      
<div className='fotogalerie-mobile-pozadi-2 fotogalerie-mobile-pozadi-auto'>
  <h1 className='jidelni-liskte-main-text-1'>SLADKÝ BAR & RAUT</h1>


  <div className="jidelni-listek-container">
    <ul className="jidelni-listek-odkazy">
      <li><a href='#'>Svatby</a></li>
      <li><a href='#polevky'>Ubytování</a></li>
      <li><a href='#lehke-menu'>Restaurace & menu</a></li>
      <li><a href='#regionalni-speciality'>Akce</a></li>

      <li><a href='#salaty'>Exteriér a okolí</a></li>
      <li><a href='#bezmase-menu'>Naše speciality</a></li>
      <li><a href='#sladke-menu'>Sladký bar</a></li>
      <li><a href='#sefkuchar-doporucuje'>Rauty</a></li>
      <li><a href='#sefkuchar-doporucuje'>Duo Jamaha</a></li>

    </ul>
  </div>

  <img className='fotogalerie-svatby-main-fotka-1' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-1.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-2.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-3.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-4.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-5.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-6.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-7.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-8.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-9.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-10.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-11.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-12.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-13.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-14.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-15.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-16.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-17.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-18.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-19.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-20.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-21.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' loading='lazy' alt='Fotografie sladkého baru' src='./img/sladky-bar/sladky-bar-22.jpg'></img>

<img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-fotogalerie-1'></img>

      <h1 className='hospudka-pod-rablinu-kontaktni-informace'>Kontaktní informace</h1>
      <img src='https://raw.githubusercontent.com/RealHajs/img-targon-cup/refs/heads/main/hospudka-pod-rablinu-logo%20(1).png' alt='Logo Hospůdka pod Rablinů' className='hospudka-pod-rablinu-logo-3'></img>


      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>Telefon</h1>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-3'>+420 608 608 101</h3>


      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>E-maily</h1>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-4'>info@hospudkapodrablinu.cz</h3>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-5'>ubytovani@hospudkapodrablinu.cz</h3>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-5'>wellness@hospudkapodrablinu.cz</h3>

      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>Sociální sítě</h1>


      <div className="socialni-site-odkazy">
        <a target='blank' href="#"><FaInstagram /></a>
        <a target='blank' href="#"><FaFacebook /></a>
        <a target='blank' href="#"><FaYoutube /></a>
        <a target='blank' href="#"><FaGooglePlus /></a>
      </div>


      <img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-6'></img>

      <h3 className='chraneno-autorskými-právy'>© 2020 - 2026 GAMPEIROS s.r.o.</h3>

    
  </div>



      </div>
    </div>
    
  );
}

export default MobileFotogalerieRauty;
